export default __webpack_public_path__ + "static/media/PlusIcon.72364d2e.svg";